const awsconfig = {
  aws_cognito_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:98c5c43a-40bd-4894-85be-e2a0f1243161',
  aws_user_files_s3_bucket: 'doc-extraction-in-prajna-dev',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

export default awsconfig;
